namespace Matrix.Workflow {
    export class TaskInstanceColumns {
        static columnsKey = 'Workflow.TaskInstance';
    }
}
